import React, { Fragment, useEffect, useState } from 'react';
import ClickCopyLabel from '../Components/ClickCopyLabel';
import Header from '../Components/Heading';
import SnippetService from '../Services/SnippetService';
import StringUtils from '../Utils/StringUtils';

export default function Authors() {
	const [ authors, setAuthors ] = useState(null);
	useEffect(() => {
		SnippetService.getAuthors()
			.then((res) => {
				setAuthors(res);
			})
			.catch();
	}, []);
	return (
		<Fragment>
			<Header text="Authors" type="h2" />
			<table className="table-auto">
				<thead>
					<tr>
						<th className="bg-blue-100 border text-left px-8 py-4">Name</th>
						<th className="bg-blue-100 border text-left px-8 py-4">Snippet</th>
						<th className="bg-blue-100 border text-left px-8 py-4">Comments</th>
					</tr>
				</thead>
				<tbody>{authors && authors.map((snippet) => <Item snippet={snippet} />)}</tbody>
			</table>
		</Fragment>
	);
}

const Item = ({ snippet }) => {
	return (
		<tr>
			<td className="border px-8 py-4"> {snippet.name}</td>
			<td className="border px-8 py-4">
				<ClickCopyLabel
					label="Snippet Id"
					text={StringUtils.wrapSnippetId(`${snippet.snippetType}#${snippet.snippetId}`)}
				/>
			</td>
			<td className="border px-8 py-4"> {snippet.comments}</td>
		</tr>
	);
};
